export default "__VITE_ASSET__f6b9756a__"